import React from "react";
import { Slideshow } from "../base/Slideshow";
import { MISSION_CONFIG } from "./missionConfig";

export default function MissionSlideshow() {
  return (
    <Slideshow
      config={{
        title: MISSION_CONFIG.slideshow.title,
        heading: MISSION_CONFIG.heading,
        subtitle: MISSION_CONFIG.subtitle,
        brand: MISSION_CONFIG.brand,
      }}
    />
  );
}
